import BoxShowcase360 from "@/components/three/BoxShowcase360";

export default function BoxShowcase() {
  return (
    <section
      id="showcase"
      data-testid="box-showcase-section"
      className="relative py-24 lg:py-32 overflow-hidden bg-[#030508]/55"
    >
      <div className="absolute inset-0 bg-grid opacity-10 pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid md:grid-cols-12 gap-8 mb-12">
          <div className="md:col-span-6">
            <span className="text-label">∙ 04 / Showcase</span>
            <h2 className="mt-4 font-display font-black uppercase tracking-tighter text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">
              360° of the
              <br />
              <span className="text-[#00F0FF] glow-cyan">real thing.</span>
            </h2>
          </div>
          <div className="md:col-span-5 md:col-start-8 self-end">
            <p className="text-white/70 leading-relaxed">
              Every X39 carton is sealed, batch-coded and shipped from
              FDA-registered facilities. Take a full 360° look at the box that
              activates over 200,000 stem cells a day.
            </p>
          </div>
        </div>

        <div className="relative aspect-[16/9] w-full glass-card overflow-hidden">
          <div className="absolute inset-0">
            <BoxShowcase360 />
          </div>

          {/* Foreground UI overlays */}
          <div className="absolute top-6 left-6 flex items-center gap-2 font-mono-ui text-[10px] tracking-[0.3em] uppercase text-white/60">
            <span className="w-2 h-2 rounded-full bg-[#00FF66] pulse-dot" />
            Live · 360° rotation
          </div>

          <div className="absolute top-6 right-6 font-mono-ui text-[10px] tracking-[0.3em] uppercase text-white/60 text-right">
            <div>SKU · X39-30P</div>
            <div className="mt-1 text-[#00F0FF]">Lot · 2026.06</div>
          </div>

          {/* Bottom HUD */}
          <div className="absolute bottom-0 inset-x-0 p-6 lg:p-8 flex flex-wrap items-end justify-between gap-6 bg-gradient-to-t from-[#030508] via-[#030508]/70 to-transparent">
            <div className="grid grid-cols-3 gap-8">
              <Spec k="30" v="patches / box" />
              <Spec k="12h" v="active wear" />
              <Spec k="∞" v="re-orderable" />
            </div>
            <div className="hidden md:flex items-center gap-2 font-mono-ui text-[10px] tracking-[0.3em] uppercase text-white/40">
              Hover · auto-rotating model
            </div>
          </div>

          {/* Corner brackets */}
          {[
            "top-3 left-3 border-l border-t",
            "top-3 right-3 border-r border-t",
            "bottom-3 left-3 border-l border-b",
            "bottom-3 right-3 border-r border-b",
          ].map((c) => (
            <span
              key={c}
              className={`absolute w-4 h-4 border-[#00F0FF]/60 ${c}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

function Spec({ k, v }) {
  return (
    <div>
      <div className="font-display font-black text-2xl lg:text-3xl text-white">
        {k}
      </div>
      <div className="font-mono-ui text-[10px] tracking-[0.25em] uppercase text-white/50 mt-1">
        {v}
      </div>
    </div>
  );
}
